module.exports = __webpack_public_path__ + "img/shiyanshizhongxin.41228cb3.jpg";